"use client";

// [VV9-TEARDOWN] all-paypal-express A/B test — delete this file at teardown.
// See the checklist in ./paypalVisibility.
import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore, useEffect } from "react";
import Cookies from "js-cookie";
import { VV9_COOKIE, VV9_FEATURE_FLAG, isVv9Variant, shouldShowPayPal } from "./paypalVisibility";
import { trackExperimentExposure } from "./exposure";
const noopSubscribe = () => () => {};

/**
 * Single entry point for both the CreditCards accepted-payments logo and the
 * PayPal Express button, so the two can never disagree about the arm and
 * never double-report exposure differently.
 *
 * PayPal Express and the logo strip render on many unrelated surfaces (home,
 * PDP, LP, cart, checkout, footer) with no single natural mount point for a
 * bespoke exposure beacon (contrast `vv5`/`vv13`, each scoped to one LP).
 * This hook fires exposure exactly once per pageload — module-level dedupe
 * lives inside `trackExperimentExposure`, keyed `flag:variant` — from
 * whichever consumer mounts first; harmless if both mount.
 *
 * SSR snapshot is `undefined`, which `shouldShowPayPal` reads as "not
 * bucketed" → shown. That keeps first paint identical to today's shipped
 * behavior on every app, and is what makes apps that never opt in
 * (apps/mirror-anchor) render PayPal exactly as before, server and client.
 * Cost of that choice: an opted-in visitor bucketed to `control` sees one
 * pre-hydration frame of the logo strip before the client snapshot hides it.
 * The Express button never flashes — it is loaded via `dynamic(ssr: false)`.
 * Removing the logo flash would mean threading middleware's `x-vv9` header
 * from the server into every call site; deliberately not done.
 */
export const usePayPalVisibility = () => {
  const $ = _c(5);
  const raw = useSyncExternalStore(noopSubscribe, _temp, _temp2);
  let t0;
  let t1;
  if ($[0] !== raw) {
    t0 = () => {
      if (!isVv9Variant(raw)) {
        return;
      }
      if (typeof window !== "undefined") {
        const override = new URLSearchParams(window.location.search).get(VV9_COOKIE);
        if (isVv9Variant(override)) {
          return;
        }
      }
      trackExperimentExposure({
        flag: VV9_FEATURE_FLAG,
        variant: raw
      });
    };
    t1 = [raw];
    $[0] = raw;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== raw) {
    t2 = shouldShowPayPal(raw);
    $[3] = raw;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp() {
  return Cookies.get(VV9_COOKIE);
}
function _temp2() {}